import { render } from "./act-add-users.vue?vue&type=template&id=9ea2b448&ts=true"
import script from "./act-add-users.ts?vue&type=script&lang=ts&external"
export * from "./act-add-users.ts?vue&type=script&lang=ts&external"

import "./act-add-users.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__